import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _RefetchEmrIntegrationRequestDtoSchema = z.object({});

const RefetchEmrIntegrationResponseDtoSchema = z.string();

export type RefetchEmrIntegrationRequestDto = z.infer<
  typeof _RefetchEmrIntegrationRequestDtoSchema
>;
export type RefetchEmrIntegrationResponseDto = z.infer<
  typeof RefetchEmrIntegrationResponseDtoSchema
>;

export const refetchEmrIntegration = (config?: AxiosRequestConfig) => {
  return api
    .post('/integrations/trigger-initial-sync', {}, config)
    .then(responseContract(RefetchEmrIntegrationResponseDtoSchema));
};
